import { useEffect } from 'react';

import { enqueueSnackbar } from '@mint-lib/notifications';

import { Box, Skeleton, Typography } from '@myn/mui';

export const ApprovalFlowFallback = () => {
  useEffect(() => {
    enqueueSnackbar({
      variant: 'error',
      title: 'Something went wrong',
      subTitle: 'Please, try again.',
      textLayout: 'inline',
      autoHideDuration: 6000,
    });
  }, []);
  return (
    <Box sx={{ display: 'flex', gap: '4px', height: '16px' }}>
      <Typography variant="label01" color="text.secondary">
        Approval status:
      </Typography>
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <Skeleton variant="rounded" width={84} height={16} />
        <Skeleton variant="rounded" width={84} height={16} />
      </Box>
    </Box>
  );
};
